import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridService } from '../shared/grid/grid.service';
import { OelType } from '../models/oelType.model';

@Injectable({
  providedIn: 'root'
})
export class OelTypeService extends GridService<OelType> {

  constructor(http: HttpClient) {
    super('OelType', http);
  }
}
